import { InjectionToken, Provider, Type } from '@angular/core';

import { OnAppInit, runOnAppInit } from '@frontend/vanilla/core';

export const ON_SPORTS_WEB_INIT = new InjectionToken<OnAppInit[]>('ON_SPORTS_WEB_INIT');

export function runOnSportsWebInit<T extends OnAppInit>(type: Type<T>): Provider[] {
    return [
        runOnAppInit(type),
        {
            provide: ON_SPORTS_WEB_INIT,
            multi: true,
            useExisting: type,
        },
    ];
}
